import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getWhiteLabel)?_c(VLayout,{attrs:{"wrap":""}},[_c(VFlex,{attrs:{"md12":"","xs12":""}},[_c('overview',{attrs:{"whitelabel-stats":_vm.whiteLabelStats}})],1),_c(VFlex,{attrs:{"xs12":""}},[_c(VCard,{attrs:{"height":"100%"}},[_c('stats-table',{attrs:{"whitelabel-stats":_vm.whiteLabelStats,"whitelabel-modules":_vm.modules}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }